export default {
	fontFamily: ['"Poppins"','sans-serif'].join(',')
}